module.exports = __webpack_public_path__ + "img/精准美肤--精准识别.05b611f5.png";